export const COLOR_PALETTE = [
  '#E2773C',
  '#E0B494',
  '#2B6297',
  '#63975B',
  '#A6B1CA',
  '#4183E5',
  '#81B2E6',
  '#D96965',
  '#A770A9',
  '#5CAFC6',
  '#C1DE6A',
  '#E5C958',
  '#DF9C5C',
  '#55AC68',
  '#4DA38A',
  '#336089',
  '#3373E0',
  '#95AAE0',
  '#9E9E6B',
  '#EA6971',
  '#57972B',
  '#65799F',
  '#5B59E4',
  '#3C3CE3',
  '#B296EE',
  '#778226',
  '#E9FB55',
];
